import contentSecurityPolicy from './contentSecurityPolicy';

// Biome keeps the keys in this file sorted (useSortedKeys in packages/core/biome.json).
export type FeatureFlagsSimplifi = {
  a2A: boolean;
  a2AInvestmentAccounts?: boolean;
  a2ASetupDashboardCard: boolean;
  accountInfoCard: boolean;
  accountListSubLevelAdd: boolean;
  accountListVisibilityPreference?: boolean;
  accountsCreditCardDashboardRelease: boolean;
  accountsFinicityWidgetExperiment: boolean;
  accountsLoginsLogActivityRelease: boolean;
  accountsManagement: boolean;
  /** LaunchDarkly key is `accounts.reconcile.release` — the dots are stripped by the camelCase transform. */
  accountsReconcileRelease: boolean;
  achievements: any;
  addFiDefaultProvider: any;
  addFiUsePlaidSearch: boolean;
  addGoalSpendingPlan: boolean;
  addfiSecPrivTrust: boolean;
  advancedReportingEnabled: boolean;
  aggErrorHandleDeadAccounts: boolean;
  aiBusinessToolsRelease: boolean;
  aiCharts: boolean;
  aiChat: boolean;
  aiChatBtnTopbar: boolean;
  aiChatLimitToolPayloads?: boolean;
  aiChatV2: boolean;
  aiContextualPromptChips: boolean;
  aiDashboardCardSummarizeRelease: boolean;
  aiInvestmentPrompts?: object;
  aiKnowledgeBase: boolean;
  aiSpendingPrompts?: object;
  aiSummarize: boolean;
  aiSummarizeEditPrompts: boolean;
  aiTransactionActions: boolean;
  /** LaunchDarkly key is `ai.whats-new.release` — the dots are stripped by the camelCase transform. */
  aiWhatsNewRelease: boolean;
  allAccountsLabelChange: boolean;
  allowAssetLiabilityLoanAccts: boolean;
  allowInvestmentAccountCreate: boolean;
  allowRegisterColumnDataGridFiltering: boolean;
  appTrackingTransparencyPrompt?: boolean;
  autoAsset: boolean;
  autoAssetV2: boolean;
  autoCategorizeUncategorized: boolean;
  barchart: boolean;
  barchartAdvanced: boolean;
  billsCalendarRelease: boolean;
  billsIncomeActivity: boolean;
  billsNewSetupExperiment?: string;
  billsTransactionHistoryExperiment: 'Reqs Not Met' | 'Control' | 'Variant A';
  billsViaAggregation?: boolean;
  bizMiles: boolean;
  browserMinVersion: {
    Chrome: string;
    Edge: string;
    Firefox: string;
    Safari: string;
  };
  btsCategories?: boolean;
  btsClientName?: string;
  budgets: boolean;
  bugReportShortcut: boolean;
  bumpAccounts: boolean;
  bumpBadges: boolean;
  bumpBusiness: boolean;
  bumpGoals: boolean;
  bumpHoldings: boolean;
  bumpInstitutionLogins: boolean;
  bumpProcessTxnUpdates: boolean;
  bumpReportConfigurations: boolean;
  bumpSecurities: boolean;
  bumpSpendingPlan: boolean;
  bumpTags: boolean;
  businessDowngrade?: boolean;
  businessUpgrade?: boolean;
  calculatorList?: any;
  calculators: boolean;
  calendarList?: boolean;
  cashFlow: boolean;
  cashflowLegendV2?: boolean;
  categorizeUncategorizedFromSpending: boolean;
  categoryIcons: boolean;
  categoryPropogationEnabled: boolean;
  categoryReviewCardWatchlist: boolean;
  categorySelectOnTab: boolean;
  ccpa: boolean;
  closeAccount: boolean;
  closedBusiness?: boolean;
  cobrowse: boolean;
  cobrowseSession: boolean;
  contentSecurityPolicy: string;
  contributeToGoalInUnlimitedPastMonths?: boolean;
  contributeToGoalOneMonthPast?: boolean;
  copyPasteEnabled: boolean;
  creditReport: boolean;
  creditReportHistory?: boolean;
  csvImport: boolean;
  customDialogButtons: boolean;
  customFrequency?: boolean;
  darkMode: boolean;
  dashboardQuickActionsExperiment: 'Reqs Not Met' | 'Control' | 'Variant A';
  dashboardTasks: boolean;
  dateKeyboardShortcuts?: boolean;
  dateOnAfter?: { value: string | number };
  debug: boolean;
  deleteAndReassignCategoryQcs: boolean;
  deleteProject: boolean;
  demoModeWhiteList: string[];
  dev: boolean;
  disableTransfers: boolean;
  discoverAccountTooltip: boolean;
  dragDialog: boolean;
  editAccountDetails: boolean;
  editRunningBalance: boolean;
  editableArAccounts?: boolean;
  enableNewRegisterToolbarFiltering: boolean;
  enableRenamePreview: boolean;
  excludeAccountBalanceFromReports?: boolean;
  excludeFromReportsSetting: boolean;
  exposeInvestmentTransactions?: string;
  featureTogglesPage?: boolean;
  feedback: boolean;
  fetchDebounce: number;
  fiCredentialEncryption: any;
  fiStatus?: boolean;
  finances: boolean;
  finicityEnv?: any;
  flagBalanceMismatchWithEvent: boolean;
  freeToSpendIosWidgetKmp: boolean;
  fundingAccountsV2: boolean;
  futureFreeToSpend: boolean;
  futureTxns?: boolean;
  globalHotKeys: boolean;
  goalWithdrawTxns: boolean;
  goals: boolean;
  goalsCalculator: boolean;
  goalsSpendingPlan: boolean;
  gsfBusinessFirstExperiment: 'Reqs Not Met' | 'Control' | 'Variant A' | 'Variant B';
  gsfNoScout: boolean;
  gsfV2: boolean;
  hearAboutSurvey: boolean;
  hideBusinessOnboardingSkip: boolean;
  hideConnectedLoanTransactions: boolean;
  hideInAccountListSetting: boolean;
  hideLoanTransactions: boolean;
  hotjar: boolean;
  ignoreAccount: boolean;
  ignoreRefreshThrottle: boolean;
  importMintBalances?: any;
  inProductNotifications: boolean;
  incomeExpenseReport?: boolean;
  institutionSearchTrimDot: boolean;
  intercom: boolean;
  investmentAccountGoalContributions?: boolean;
  investmentBalanceChart?: boolean;
  investmentBalancesTotalChart?: boolean;
  investmentCard1DayChange?: boolean;
  investmentsDetailedQuotesRelease?: boolean;
  investmentGains?: boolean;
  investmentPerformance: boolean;
  /** LaunchDarkly key is `investment-transaction-detail.redesign.release` — the dots are stripped by the camelCase transform. */
  investmentTransactionDetailRedesignRelease: boolean;
  investmentTransactions: boolean;
  investmentTransactionsReports: boolean;
  investmentWidgetLogos: boolean;
  investmentsAcme: boolean;
  /** LaunchDarkly key is `investments.sync-holdings.release` — the dots are stripped by the camelCase transform. */
  investmentsSyncHoldingsRelease: boolean;
  investmentsWhy?: boolean;
  invoiceTerms?: boolean;
  invoiceTips?: boolean;
  lab: boolean;
  ldHasDatasetId?: boolean;
  ldHasDatasetTier?: boolean;
  limit?: number;
  loggingLevel: any;
  logosPayeeAutoLookupRelease: boolean;
  logosSeriesRelease: boolean;
  maintenance: any;
  manageAccountsGroupManualByType: boolean;
  manualAccountBalanceRefresh: boolean;
  manualHoldings: boolean;
  matchAmountVariants?: number;
  maxAttachmentsPerTxn: number;
  maxCategoryDepth: number;
  maxDatasets: number;
  mcpConnectedAiRelease: boolean;
  memorizedRuleApplyToExistingQcs: boolean;
  mileageAddressAutofillAndDistanceRelease: boolean;
  mintImportAsync?: boolean;
  mintImportExtension?: boolean;
  mixpanelProxy: boolean;
  mixpanelSessionReplay: boolean;
  mobilePaywallAnnualTier?: boolean;
  mobilePaywallLiteTier?: boolean;
  mobilePaywallMonthlyTier?: boolean;
  mobilePaywallNewFlag?: 'none' | 'control' | 'new';
  mobilePaywallUpdates?: boolean;
  mobileReportDateRange?: boolean;
  mobileReportsBreakdown?: boolean;
  monthlyAnnualAlert: boolean;
  monthlySummary: boolean;
  nativeBackgroundSync: boolean;
  nativeRefreshTimeout: number;
  navLeftNavRedesignExperiment: 'Reqs Not Met' | 'Control' | 'Variant A';
  netWorth: boolean;
  networthByAccountBreakdownRelease: boolean;
  netWorthV2Feature: boolean;
  newCategorySettingsEnabled: boolean;
  noDateOnBankPending: boolean;
  notificationPreferences: boolean;
  notifications: boolean;
  nps: number;
  offerReplacementOnDelete: boolean;
  orphanedInstitutionLogins?: boolean;
  payeeAutoFillAmount: boolean;
  payeeAutoFillCat: boolean;
  payeeAutoFillMemo: boolean;
  payeeAutoFillTags: boolean;
  payeeFieldsIncludeAllAccounts: boolean;
  payeeRuleMultiselect?: boolean;
  payeeShowFillInfoInMenu: boolean;
  pendo: any;
  persist: boolean;
  persistDebounceDuration: number;
  persistPurgeVersion: any;
  plaidEnv?: any;
  plaidWidget: boolean;
  plannedSpendingAutoRelease: boolean;
  plannedSpendingRollovers: boolean;
  plannedSpendingSummary: boolean;
  plannedSpendingViewToggle: boolean;
  planningTools: boolean;
  playBilling: boolean;
  prefAdvancedOption: boolean;
  prefAllowEditingAmounts: boolean;
  prefAutoSaveEditedTransactions: boolean;
  prefAutoSearch: boolean;
  prefColoredAccounts: boolean;
  prefCurrencySymbolTransactionList: boolean;
  prefDeleteDownloaded: boolean;
  prefLongCatName: boolean;
  prefMoneyInOutColumn: boolean;
  prefNewTransactionEntry: boolean;
  prefShowPreferences: boolean;
  prefWrapText: boolean;
  privacyMode?: boolean;
  profileHelpSupport: boolean;
  projectedBalances: boolean;
  purchasingRcPaywallRelease?: boolean;
  qCardsOn: boolean;
  qbpCsvProductsServices?: boolean;
  qbpGuestClient: boolean;
  qbpMileageTrackerReports: boolean;
  qbpUsageTxnrulesv2?: boolean;
  qdgQuickFilter: boolean;
  realTimeQuotes: boolean;
  reauthV2?: boolean;
  receiptsAutoSplitGenerationRelease: boolean;
  receiptsCaptureRelease: boolean;
  receiptsConfirmBeforeUploadRelease: boolean;
  receiptsExtractionFeedbackRelease: boolean;
  receiptsTransactionUploadRelease: boolean;
  recentTxnAcme: boolean;
  reconcileAccounts: boolean;
  recurringManagement: boolean;
  recurringMatchCriteria?: boolean;
  refreshPollInterval: number;
  refreshPollTimeout: number;
  refundTracker: boolean;
  registerInvestmentCategoryRelease: boolean;
  registerSplitViewFilterScopeRelease: boolean;
  registerToolbarDatePicker: boolean;
  registerToolbarV2: boolean;
  relyOnSecurities: boolean;
  renameRuleApplyToExistingQcs: boolean;
  reportExportToTax?: boolean;
  reportGridGraph: boolean;
  reportTaxDetailBusiness?: boolean;
  reportTaxDetailPersonal?: boolean;
  reports: boolean;
  reportsClientTxns?: boolean;
  /**
   * Appends the report's chart to Print and Export → PDF (SIMPL-36514). LaunchDarkly key is
   * `reports.chart-print.release` — the dots are stripped by the camelCase transform.
   */
  reportsChartPrintRelease: boolean;
  /** LaunchDarkly key is `reports.comparison-over-time.release` — the dots are stripped by the camelCase transform. */
  reportsComparisonOverTimeRelease: boolean;
  /** LaunchDarkly key is `reports.comparison-reports.release` — the dots are stripped by the camelCase transform. */
  reportsComparisonReportsRelease: boolean;
  /** LaunchDarkly key is `reports.comparison-waterfall.release` — the dots are stripped by the camelCase transform. */
  reportsComparisonWaterfallRelease: boolean;
  reportsDynamicDateRangeRelease?: boolean;
  reportsExposeExportPrintExperiment?: string;
  reportsIgnoreExcludedAccounts: boolean;
  reportsMobileRefactor?: boolean;
  reportsMoveRfndtrkrCrdtscr: boolean;
  reportsOpenSave?: boolean;
  reportsPrint?: boolean;
  reportsPrintLegacy?: boolean;
  reportsReplaceLegacy?: boolean;
  reportsSankeyChart: boolean;
  reportsSplitsList: boolean;
  reportsStickyConfig: boolean;
  reportsSummary: boolean;
  reportsTransactionsRegister: boolean;
  reportsV3: string;
  /** LaunchDarkly key: `retail.purchase-categorization.release`. */
  retailPurchaseCategorizationRelease: boolean;
  retirementPlanner: boolean;
  scheduledTransactions: boolean;
  scheduledTransactionsInRegister: boolean;
  securities: boolean;
  securitiesSettings: any;
  serviceWorkerEnable: boolean;
  serviceWorkerEnableInstall: boolean;
  serviceWorkerEnablePushNotifications: boolean;
  serviceWorkerUpdateInterval: number;
  serviceWorkerUpdateOnIdleTimeout: number;
  serviceWorkerUpdateOnIdleWindow: number;
  serviceWorkerUpdateOnLoad: boolean;
  serviceWorkerUpdateOnNavigation: boolean;
  serviceWorkerUserUpdateTimeout: number;
  serviceWorkerUserUpdateWindow: number;
  settingsSubscriptionUpsell: boolean;
  setupChecklist: number;
  sharingEnabled: boolean;
  showInvestmentsCard?: boolean;
  showTxnJson: boolean;
  sourceColumnEnabled: boolean;
  spendingAndIncomeTabs?: boolean;
  spendingAndIncomeTabsSticky?: boolean;
  spendingDashboard: boolean;
  spendingPlan: boolean;
  spendingPlanBillGrouping: boolean;
  spendingPlanClientCalc?: boolean;
  spendingPlanCloseout?: boolean;
  spendingPlanPastRolloverControl: boolean;
  spendingPlanRollForward: boolean;
  spendingPlanSetup: any;
  spendingPlanTransfers: boolean;
  spendingWatchList: boolean;
  splitSeries: boolean;
  splitShowNotes: boolean;
  splitSwitchOnLeft: boolean;
  splitsAlwaysShow: boolean;
  splitsDetailsInDialog: boolean;
  splitsSideBySide: boolean;
  splitsV2?: boolean;
  startYAxisAtZero: boolean;
  stockLogo: boolean;
  subscriptionAlerts: boolean;
  subscriptionsV2?: boolean;
  suggestCategoryForUncategorized: boolean;
  survey: boolean;
  systemAutoRefreshThrottleOperations: number;
  tagsAsHashes: boolean;
  tasksServerDrivenRelease: boolean;
  taxItemsEnabled: boolean;
  taxPlanner: boolean;
  taxPlannerOnboarding: boolean;
  tickerValidate: string;
  timeTracking?: boolean;
  todoList?: boolean;
  trackLogoTicker: boolean;
  transactionDetailsComprehensive: boolean;
  transactionFilters: boolean;
  transactionsDaysToLoadRelease: number;
  transactionsEnhancedDetailViewRelease: boolean;
  transactionsFeedbackRelease: boolean;
  /**
   * LaunchDarkly key is `transactions.incremental-selectors.release` — the dots are stripped by the camelCase transform.
   * Kill switch: off, selectors recompute from the full transaction map on every change.
   */
  transactionsIncrementalSelectorsRelease: boolean;
  /** LaunchDarkly key is `transactions.native-review.release` — the dots are stripped by the camelCase transform. */
  transactionsNativeReviewRelease?: boolean;
  transactionsReviewExperienceRelease: boolean;
  transactionsSettings: boolean;
  transactionsSize?: number;
  txnCancelExtraColumn: boolean;
  txnDetailsModal: boolean;
  txnRulesAdvanced: boolean;
  txnRulesIfAccount: boolean;
  undo: any;
  upcoming: boolean;
  upcomingRedesign: boolean;
  urlDialog: boolean;
  userGuideEnabled: boolean;
  watchlistSetup: number;
  watchlistTimeSelector: boolean;
  webDrawerInput: boolean;
  webSocketQcs: number;
  webSocketQcsWatchList: boolean;
  wellnessPageRelease: boolean;
  wellnessServerCalcsRelease: boolean;
  zeroStateOnNoAccounts: boolean;
};

const featureFlagBaseDefaults: FeatureFlagsSimplifi = {
  a2A: false,
  a2ASetupDashboardCard: false,
  accountInfoCard: false,
  accountListSubLevelAdd: false,
  accountsCreditCardDashboardRelease: false,
  accountsFinicityWidgetExperiment: false,
  accountsLoginsLogActivityRelease: true,
  accountsManagement: true,
  accountsReconcileRelease: false,
  achievements: true,
  addFiDefaultProvider: 'USE_PREFERENCE_SERVICE',
  addFiUsePlaidSearch: false,
  addGoalSpendingPlan: false,
  addfiSecPrivTrust: false,
  advancedReportingEnabled: true,
  aggErrorHandleDeadAccounts: true,
  aiBusinessToolsRelease: false,
  aiCharts: false,
  aiChat: false,
  aiChatBtnTopbar: true,
  aiChatLimitToolPayloads: false,
  aiChatV2: true,
  aiContextualPromptChips: true,
  aiDashboardCardSummarizeRelease: false,
  aiInvestmentPrompts: undefined, // Prompts are loaded from the file if FF fails to load.
  aiKnowledgeBase: false,
  aiSpendingPrompts: undefined, // Prompts are loaded from the file if FF fails to load.
  aiSummarize: false,
  aiSummarizeEditPrompts: false,
  aiTransactionActions: false,
  aiWhatsNewRelease: false, // LD key: ai.whats-new.release
  allAccountsLabelChange: false,
  allowAssetLiabilityLoanAccts: true,
  allowInvestmentAccountCreate: true,
  allowRegisterColumnDataGridFiltering: true,
  autoAsset: false,
  autoAssetV2: false,
  autoCategorizeUncategorized: true,
  barchart: false,
  barchartAdvanced: false,
  billsCalendarRelease: false,
  billsIncomeActivity: true,
  billsNewSetupExperiment: 'Reqs Not Met',
  billsTransactionHistoryExperiment: 'Reqs Not Met',
  billsViaAggregation: false,
  bizMiles: false,
  browserMinVersion: {
    Chrome: '92',
    Edge: '92',
    Firefox: '90',
    Safari: '15.4',
  },
  budgets: false,
  bugReportShortcut: false,
  bumpAccounts: false,
  bumpBadges: false,
  bumpBusiness: false,
  bumpGoals: false,
  bumpHoldings: false,
  bumpInstitutionLogins: false,
  bumpProcessTxnUpdates: true,
  bumpReportConfigurations: false,
  bumpSecurities: false,
  bumpSpendingPlan: false,
  bumpTags: false,
  calculators: false,
  cashFlow: true,
  cashflowLegendV2: false,
  categorizeUncategorizedFromSpending: false,
  categoryIcons: false,
  categoryPropogationEnabled: true,
  categoryReviewCardWatchlist: true,
  categorySelectOnTab: false,
  ccpa: true,
  closeAccount: false,
  closedBusiness: false,
  cobrowse: true,
  cobrowseSession: false,
  contentSecurityPolicy,
  copyPasteEnabled: false,
  creditReport: false,
  csvImport: true,
  customDialogButtons: true,
  customFrequency: true,
  darkMode: false,
  dashboardQuickActionsExperiment: 'Reqs Not Met',
  dashboardTasks: false,
  debug: false,
  deleteAndReassignCategoryQcs: false,
  deleteProject: false,
  demoModeWhiteList: [
    '^get:',
    'post:.*/gamification/event',
    'post:.*/transactions/earliest-date-on',
    'post:.*/job-statuses',
    'delete:.*/job-statuses/.*',
    'post:.*/oauth/token',
    'post:.*/reports/generate',
    'post:.*/logos/tickers',
    'post:.*/v2/investments/quotes.*',
    'post:.*/goals/analysis-async',
    'post:.*/institution-logins/refresh',
  ],
  dev: false,
  disableTransfers: false,
  discoverAccountTooltip: true,
  dragDialog: false,
  editAccountDetails: false,
  editRunningBalance: false,
  editableArAccounts: false,
  enableNewRegisterToolbarFiltering: true, // toggles register filtering using data grid
  enableRenamePreview: true,
  excludeFromReportsSetting: false,
  feedback: true,
  fetchDebounce: 3000,
  fiCredentialEncryption: false,
  finances: false,
  flagBalanceMismatchWithEvent: false,
  freeToSpendIosWidgetKmp: false,
  fundingAccountsV2: false,
  futureFreeToSpend: false,
  globalHotKeys: false,
  goalWithdrawTxns: false,
  goals: true,
  goalsCalculator: false,
  goalsSpendingPlan: true,
  gsfBusinessFirstExperiment: 'Reqs Not Met',
  gsfNoScout: true,
  gsfV2: true,
  hearAboutSurvey: false,
  hideBusinessOnboardingSkip: false,
  hideConnectedLoanTransactions: true,
  hideInAccountListSetting: false,
  hideLoanTransactions: false,
  hotjar: false,
  ignoreAccount: false,
  ignoreRefreshThrottle: false,
  inProductNotifications: true,
  institutionSearchTrimDot: true,
  intercom: false,
  investmentPerformance: false,
  investmentTransactionDetailRedesignRelease: false,
  investmentTransactions: true,
  investmentTransactionsReports: false,
  investmentWidgetLogos: true,
  investmentsAcme: true,
  investmentsDetailedQuotesRelease: false,
  investmentsSyncHoldingsRelease: false, // LD key: investments.sync-holdings.release
  investmentsWhy: false,
  invoiceTerms: false,
  invoiceTips: false,
  lab: false,
  ldHasDatasetId: false,
  ldHasDatasetTier: false,
  loggingLevel: 2,
  logosPayeeAutoLookupRelease: false,
  logosSeriesRelease: false,
  maintenance: false,
  manageAccountsGroupManualByType: false,
  manualAccountBalanceRefresh: false,
  manualHoldings: true,
  maxAttachmentsPerTxn: 5,
  maxCategoryDepth: 2,
  maxDatasets: 1,
  mcpConnectedAiRelease: false,
  memorizedRuleApplyToExistingQcs: false,
  mileageAddressAutofillAndDistanceRelease: false,
  mixpanelProxy: true,
  mixpanelSessionReplay: false,
  mobilePaywallAnnualTier: true,
  mobilePaywallMonthlyTier: true,
  mobilePaywallNewFlag: 'none',
  mobilePaywallUpdates: false,
  monthlyAnnualAlert: false,
  monthlySummary: true,
  nativeBackgroundSync: true,
  nativeRefreshTimeout: 120000,
  navLeftNavRedesignExperiment: 'Reqs Not Met',
  netWorth: true,
  netWorthV2Feature: true,
  networthByAccountBreakdownRelease: true,
  newCategorySettingsEnabled: false,
  noDateOnBankPending: true,
  notificationPreferences: true,
  notifications: true,
  nps: 10000,
  offerReplacementOnDelete: true,
  payeeAutoFillAmount: false,
  payeeAutoFillCat: false,
  payeeAutoFillMemo: false,
  payeeAutoFillTags: false,
  payeeFieldsIncludeAllAccounts: false,
  payeeShowFillInfoInMenu: false,
  pendo: true,
  persist: false,
  persistDebounceDuration: 1000,
  persistPurgeVersion: null,
  plaidWidget: false,
  plannedSpendingAutoRelease: false,
  plannedSpendingRollovers: false,
  plannedSpendingSummary: false,
  plannedSpendingViewToggle: false,
  planningTools: true,
  playBilling: true,
  prefAdvancedOption: false,
  prefAllowEditingAmounts: false,
  prefAutoSaveEditedTransactions: false,
  prefAutoSearch: false,
  prefColoredAccounts: false,
  prefCurrencySymbolTransactionList: false,
  prefDeleteDownloaded: false,
  prefLongCatName: false,
  prefMoneyInOutColumn: false,
  prefNewTransactionEntry: false,
  prefShowPreferences: false,
  prefWrapText: false,
  privacyMode: true,
  profileHelpSupport: false,
  projectedBalances: true,
  purchasingRcPaywallRelease: false,
  qCardsOn: false,
  qbpCsvProductsServices: false,
  qbpGuestClient: false,
  qbpMileageTrackerReports: false,
  qdgQuickFilter: true,
  realTimeQuotes: true,
  receiptsAutoSplitGenerationRelease: false,
  receiptsCaptureRelease: false,
  receiptsConfirmBeforeUploadRelease: false,
  receiptsExtractionFeedbackRelease: false,
  receiptsTransactionUploadRelease: false,
  recentTxnAcme: true,
  reconcileAccounts: false,
  recurringManagement: false,
  refreshPollInterval: 3000,
  refreshPollTimeout: 300000,
  refundTracker: false,
  registerInvestmentCategoryRelease: false, // scopes the security description to investment accounts
  registerSplitViewFilterScopeRelease: false,
  registerToolbarDatePicker: false, // toggles the date picker in the register toolbar
  registerToolbarV2: false, // toggles between the old register toolbar and the new
  relyOnSecurities: false,
  renameRuleApplyToExistingQcs: false,
  reportExportToTax: true,
  reportGridGraph: false,
  reportTaxDetailPersonal: true,
  reports: true,
  reportsChartPrintRelease: false,
  reportsComparisonOverTimeRelease: false,
  reportsComparisonReportsRelease: false,
  reportsComparisonWaterfallRelease: false,
  reportsDynamicDateRangeRelease: false,
  reportsExposeExportPrintExperiment: 'Reqs Not Met',
  reportsIgnoreExcludedAccounts: false,
  reportsMobileRefactor: false,
  reportsMoveRfndtrkrCrdtscr: false,
  reportsOpenSave: true,
  reportsPrintLegacy: false,
  reportsReplaceLegacy: false,
  reportsSankeyChart: false,
  reportsSplitsList: false,
  reportsStickyConfig: false,
  reportsSummary: false,
  reportsTransactionsRegister: true,
  reportsV3: '',
  retailPurchaseCategorizationRelease: false,
  retirementPlanner: false,
  scheduledTransactions: true,
  scheduledTransactionsInRegister: true,
  securities: false,
  securitiesSettings: false,
  serviceWorkerEnable: true,
  serviceWorkerEnableInstall: false,
  serviceWorkerEnablePushNotifications: false,
  serviceWorkerUpdateInterval: 300000,
  serviceWorkerUpdateOnIdleTimeout: -1,
  serviceWorkerUpdateOnIdleWindow: 600000,
  serviceWorkerUpdateOnLoad: false,
  serviceWorkerUpdateOnNavigation: false,
  serviceWorkerUserUpdateTimeout: 0,
  serviceWorkerUserUpdateWindow: 0,
  settingsSubscriptionUpsell: false,
  setupChecklist: 0,
  sharingEnabled: false,
  showTxnJson: false,
  sourceColumnEnabled: false,
  spendingAndIncomeTabs: false,
  spendingAndIncomeTabsSticky: false,
  spendingDashboard: false,
  spendingPlan: true,
  spendingPlanBillGrouping: false,
  spendingPlanPastRolloverControl: false,
  spendingPlanRollForward: false,
  spendingPlanSetup: '1603177200',
  spendingPlanTransfers: false,
  spendingWatchList: true,
  splitSeries: true,
  splitShowNotes: false,
  splitSwitchOnLeft: false,
  splitsAlwaysShow: true,
  splitsDetailsInDialog: false,
  splitsSideBySide: false,
  startYAxisAtZero: false,
  stockLogo: false,
  subscriptionAlerts: false,
  suggestCategoryForUncategorized: false,
  survey: false,
  systemAutoRefreshThrottleOperations: -1,
  tagsAsHashes: false,
  tasksServerDrivenRelease: false,
  taxItemsEnabled: true,
  taxPlanner: false,
  taxPlannerOnboarding: false,
  tickerValidate: '^[A-Z]{1,5}(\\.[A-Z]{1,3})?$',
  trackLogoTicker: false,
  transactionDetailsComprehensive: false,
  transactionFilters: true,
  transactionsDaysToLoadRelease: 0,
  transactionsEnhancedDetailViewRelease: false,
  transactionsFeedbackRelease: false,
  transactionsIncrementalSelectorsRelease: true,
  transactionsNativeReviewRelease: true,
  transactionsReviewExperienceRelease: false,
  transactionsSettings: false,
  txnCancelExtraColumn: true,
  txnDetailsModal: true,
  txnRulesAdvanced: true,
  txnRulesIfAccount: false,
  undo: 10,
  upcoming: true,
  upcomingRedesign: false,
  urlDialog: false,
  userGuideEnabled: false,
  watchlistSetup: 1603177200,
  watchlistTimeSelector: false,
  webDrawerInput: false,
  webSocketQcs: 0,
  webSocketQcsWatchList: false,
  wellnessPageRelease: false,
  wellnessServerCalcsRelease: false,
  zeroStateOnNoAccounts: false,
};

export const featureFlagsSimplifiDefaults: FeatureFlagsSimplifi = {
  ...featureFlagBaseDefaults,
  aiKnowledgeBase: true,
};

export const featureFlagsSimplifiQBPDefaults: FeatureFlagsSimplifi = {
  ...featureFlagBaseDefaults,
  bizMiles: true,
  bumpBusiness: true,
  dashboardTasks: true,
  editableArAccounts: true,
  fundingAccountsV2: true,
  gsfNoScout: false,
  gsfV2: false,
  incomeExpenseReport: true,
  invoiceTerms: true,
  invoiceTips: true,
  maxCategoryDepth: 3,
  maxDatasets: 3,
  qbpCsvProductsServices: true,
  qbpMileageTrackerReports: true,
  qbpUsageTxnrulesv2: true,
  reportTaxDetailBusiness: true,
  reportsV3: 'profit-loss, net-income, taxes',
  taxPlanner: true,
  taxPlannerOnboarding: true,
};

export const featureFlagsSimplifiLiteDefaults: FeatureFlagsSimplifi = {
  ...featureFlagBaseDefaults,
  a2A: false,
  advancedReportingEnabled: false,
  aiChat: false,
  aiChatBtnTopbar: false,
  aiChatV2: false,
  aiContextualPromptChips: false,
  aiSummarize: false,
  creditReport: false,
  finances: false,
  investmentsAcme: false,
  investmentsWhy: false,
  maxDatasets: 1,
  netWorth: false,
  netWorthV2Feature: false,
  networthByAccountBreakdownRelease: false,
  planningTools: false,
  reportExportToTax: false,
  reportTaxDetailPersonal: false,
  securitiesSettings: false,
  sharingEnabled: false,
  showInvestmentsCard: false,
  spendingDashboard: false,
  taxItemsEnabled: false,
};
